/**
 * Header is permanently fixed at the top of the viewport on this site, so
 * this module only maintains the `.header--top` class hook for any styling
 * that wants to behave differently when the page is scrolled away from 0.
 *
 * @param {import('lenis').default} lenisInstance The initialized Lenis instance.
 */
let currentLenisInstance = null;
let scrollHandler = null;

export function initializeStickyHeader(lenisInstance) {
    if (!lenisInstance) return;

    if (scrollHandler) {
        destroyStickyHeader();
    }

    const header = document.getElementById('header');
    if (!header) return;

    const handleScroll = (e) => {
        const scrollY = e.scroll;
        header.classList.toggle('header--top', scrollY <= 1);
    };

    handleScroll({ scroll: lenisInstance.scroll });

    scrollHandler = handleScroll;
    currentLenisInstance = lenisInstance;
    lenisInstance.on('scroll', scrollHandler);
}

export function destroyStickyHeader() {
    if (currentLenisInstance && scrollHandler) {
        currentLenisInstance.off('scroll', scrollHandler);
    }
    scrollHandler = null;
    currentLenisInstance = null;
}
